// extracted by mini-css-extract-plugin
export default {"form":"NewMulti_form__xLcow","input":"NewMulti_input__AXhdX","impexp":"NewMulti_impexp__GvM1B"};